module.exports = __webpack_public_path__ + "static/media/101.19e49fb7.jpg";